import { useQuery } from "@tanstack/react-query";
import axiosManager from "../../../../services/axiosManager";

export const useGetPreviousEducation = (studentId) => {
    const {
        isLoading, data: previousEducation, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: [`student/${studentId}/PreviousEducation`],
        queryFn: () => axiosManager.get$(`/parent/api/students/${studentId}/PreviousEducation`).then((response) => response?.data),
        retry: 0,
        enabled: !!studentId,
    });

    return {
        isLoading,
        previousEducation: previousEducation || {},
        error,
        refetch,
        isRefetching,
    };
};
